export const DEFAULT_ROUTE_OPTIONS = [
  { label: "Inbox", value: "inbox", suffix: "/inbox" },
  // Safe under a flag flip: with WIDGETS off, /my-work redirects to the
  // workspace root, which renders the legacy Home dashboard (no loop).
  { label: "My Work", value: "my-work", suffix: "/my-work" },
  { label: "Workflows", value: "workflows", suffix: "/workflows" },
  { label: "Map", value: "Map", suffix: "/map" },
] as const;

/**
 * Workspace-relative suffix for a user's chosen landing route. An unknown or
 * retired value falls back to Inbox.
 */
export function getDefaultRouteSuffix(route: string | null | undefined): string {
  return DEFAULT_ROUTE_OPTIONS.find((r) => r.value === route)?.suffix ?? "/inbox";
}
